module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "TOC"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")])]), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('p', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/001coverpage"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/002titlepage"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("Title Page")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "dedicationpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/003dedicationpage01#dedicationpage01"
    }
  }, [_c('span', {
    staticClass: "color",
    attrs: {
      "id": "ded"
    }
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "frontmatterpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005frontmatterpage01#frontmatterpage01"
    }
  }, [_vm._v("Foreword by Michael Anthony")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter01#chapter01"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006chapter01#chapter01"
    }
  }, [_c('i', [_vm._v("Hard Luck Son of a Bitch")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter02#chapter02"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter02#chapter02"
    }
  }, [_c('i', [_vm._v("Mobile Home Blues")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter03#chapter03"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter03#chapter03"
    }
  }, [_c('i', [_vm._v("Going to San Francisco")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter04#chapter04"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter04#chapter04"
    }
  }, [_c('i', [_vm._v("Montrose")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter05#chapter05"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter05#chapter05"
    }
  }, [_c('i', [_vm._v("The Red Rocker")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter06#chapter06"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter06#chapter06"
    }
  }, [_c('i', [_vm._v("I Can’t Drive Fifty-five")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "photo_insert1"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter06#photoinsert1"
    }
  }, [_vm._v("Photographic Insert I")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter07#chapter07"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter07#chapter07"
    }
  }, [_c('i', [_vm._v("5150")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter08#chapter08"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter08#chapter08"
    }
  }, [_c('i', [_vm._v("Monsters of Rock")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter09#chapter09"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter09#chapter09"
    }
  }, [_c('i', [_vm._v("Right Here, Right Now")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter10#chapter10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter10#chapter10"
    }
  }, [_c('i', [_vm._v("Cabo Wabo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter11#chapter11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter11#chapter11"
    }
  }, [_c('i', [_vm._v("Father’s Day")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/017chapter12#chapter12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/017chapter12#chapter12"
    }
  }, [_c('i', [_vm._v("Mas Tequila")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/018chapter13#chapter13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/018chapter13#chapter13"
    }
  }, [_c('i', [_vm._v("Enter Irving")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/019chapter14#chapter14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/019chapter14#chapter14"
    }
  }, [_c('i', [_vm._v("Samurai Hair")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "photo_insert2"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/019chapter14#photoinsert2"
    }
  }, [_vm._v("Photographic Insert II")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/020chapter15#chapter15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/020chapter15#chapter15"
    }
  }, [_c('i', [_vm._v("Going Home")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "chapter_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/021chapter16#chapter16"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/021chapter16#chapter16"
    }
  }, [_c('i', [_vm._v("Who Wants to Be a Billionaire?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "backmatterpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/022backmatterpage01#backmatterpage01"
    }
  }, [_vm._v("Note from the Coauthor")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "acknowledgmentpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/023acknowledgmentpage01#acknowledgmentpage01"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "exc"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt#exc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from ARE WE HAVING ANY FUN YET?")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "aboutauthor_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/024aboutauthorpage#aboutauthorpage"
    }
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "credits_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/025creditspage#creditspage"
    }
  }, [_vm._v("Credits")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780062042361_Hagar_adcard#zhead1",
      "id": "zhead2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books by Sammy Hagar")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "copyright_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/026copyrightpage#copyrightpage"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    staticStyle: {
      "text-indent": "0%"
    },
    attrs: {
      "id": "aboutpublisher_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/027aboutpublisherpage#aboutpublisherpage"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7bcecf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004-TOC.vue
// module id = 66
// module chunks = 0